export default {"src":"/_next/static/media/play.4624afae.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};